var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-mx-auto tw-mt-8 tw-max-w-md"},[_vm._m(0),_vm._v(" "),_c('login-form',{staticClass:"box",attrs:{"redirect":_vm.redirect}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h1',{staticClass:"tw-text-center tw-font-sans tw-text-3xl tw-font-bold tw-text-gray-900"},[_vm._v("Log in")])])
}]

export { render, staticRenderFns }